import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {Audit, IAudit} from '../models/audit.model';
@Injectable({
  providedIn: 'root'
})
export class AuditService {

  constructor(private http: HttpClient) { }
  getAudit(): Observable<any> {
  return this.http.get<any>(`${environment.url}/audits`);
  }
  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/audits` + (size ? '?page=' + page + '&size=' + size : ''));
  }
  getAuditBycurrentSearch(search: string, page: number, size: number) {
    return this.http.get<any>(`${environment.url}/audits` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size));
  }
  saveAudit(Audit: IAudit) {
    return this.http.post<any>(`${environment.url}/audits`, Audit);
  }
  getidAudit(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/audits/` + idA, {'headers': headers});
  }
  updateAudit(Audit: IAudit) {
    return this.http.put<any>(`${environment.url}/audits/` + Audit.id, Audit);
  }
  deleteAudit(idA: number) {
    return this.http.delete(`${environment.url}/audits/` + idA);
  }

  auditsFilter(page: number, size: number, startDate: string, endDate: string, actor: string, action: string, objectId: string, objectType: string): Observable<any>{
    let headers = new HttpHeaders();
    headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/audits/search?page=${page}&size=${size}&startDate=${startDate}&endDate=${endDate}&actor=${actor}&action=${action}&objectId=${objectId}&objectType=${objectType}`, {'headers': headers})
  }
}
